<h2 mat-dialog-title>
  {{ "TRANSACTION_DETAILS.BPMN_DIAGRAM" | translate }} ({{
    datasource.transaction.workflowInstanceKey
  }})
</h2>

<mat-dialog-content>
  <!-- TODO: Update when API is available. -->
  <!-- Sample SVG -->
  <svg width="400" height="180">
    <rect
      x="50"
      y="20"
      width="150"
      height="150"
      style="fill: blue; stroke: pink; stroke-width: 5; opacity: 0.5"
    />
    {{ "BPMN_DIALOG.BROWSER_NOT_SUPPORTED" | translate }}
  </svg>
</mat-dialog-content>

<mat-dialog-actions>
  <button mat-raised-button color="warn" [mat-dialog-close]="">
    {{ "DIALOGS.CLOSE" | translate }}
  </button>
</mat-dialog-actions>
